import React from 'react'
import Grid from '@mui/material/Grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

/**
 * Shared checkbox section for inQuiz and isSeminalWork flags.
 * Used by admin modals and creation forms.
 */
const ResourceCheckboxes = ({ inQuiz, setInQuiz, isSeminalWork, setIsSeminalWork }) => {
    return (
        <Grid item xs={12} md={6}>
            <FormControlLabel
                control={<Checkbox checked={inQuiz} onChange={e => setInQuiz(e.target.checked)} />}
                label="Include in Quiz"
            />
            <FormControlLabel
                control={<Checkbox checked={isSeminalWork} onChange={e => setIsSeminalWork(e.target.checked)} />}
                label="Seminal Work"
            />
        </Grid>
    )
}

export default ResourceCheckboxes
